import { AxiosRequestConfig } from 'axios';

export enum ErrorType {
  TaskNotFound = 'Task not found',
  TasksNotFound = 'Tasks not found',
  ExecutionsNotFound = 'Execution logs not found',
  USDPriceNotFound = 'USD Price is not defined!',
  ConfigNotFound = 'Config is not defined!',
  ABINotFound = 'Config is not defined!',
}

export const AXIOS_DEFAULT_CONFIG: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
};
